import useAuth from "../Auth/hooks/useAuth";
import {UserAccountRoles} from "../constants";
import {FeatureFlags} from "../featureFlags";
import {useIsFeatureEnabledBoolean} from "../Hooks/useIsFeatureEnabledBoolean";

export const useIsAmboExperience = () => {
    const {user} = useAuth();
    const isAmboExperienceEnabled = useIsFeatureEnabledBoolean(FeatureFlags.AMBO_INBOX_EXPERIENCE);

    const isAmboExperience =
        isAmboExperienceEnabled &&
        (user?.accountRole === UserAccountRoles.MENTOR ||
            user?.accountRole === UserAccountRoles.STAFF);

    return {
        isAmboExperience,
    };
};
